module.exports = __webpack_public_path__ + "static/media/hospital.26502ae7.jpg";